import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Carousel from '@sitebase/ui-kit/es/Carousel';
import ThemeProvider from '@sitebase/theme-context/es/ThemeProvider';

import ProductNavItem from './ProductNavItem';
import { getAllowedAttributes } from '../../props-filters';
import HeaderContext from '../../Layout/HeaderContext';
import './ProductNav.scss';

var ProductNav = function ProductNav(_ref) {
  var children = _ref.children,
      slot = _ref.slot,
      activeItemIndex = _ref.activeItemIndex,
      restProps = _objectWithoutProperties(_ref, ['children', 'slot', 'activeItemIndex']);

  return React.createElement(
    HeaderContext.Consumer,
    null,
    function (_ref2) {
      var type = _ref2.type;
      return React.createElement(
        ThemeProvider,
        { theme: 'dark' },
        React.createElement(
          'div',
          { className: cx('sb-header-nav', { 'sb-header-nav--mobile': type === 'mobile' }) },
          React.createElement(
            Carousel,
            _extends({
              outfit: 'stretched transparent',
              activeElement: activeItemIndex
            }, getAllowedAttributes(restProps)),
            children
          )
        )
      );
    }
  );
};

ProductNav.propTypes = {
  slot: PropTypes.oneOf(['product-nav']),
  children: PropTypes.arrayOf(ProductNavItem),
  activeItemIndex: PropTypes.number
};

export default ProductNav;
//# sourceMappingURL=ProductNav.js.map